import axios, { AxiosError, type AxiosInstance } from 'axios'
import { RESP_OK, type ApiResp } from '@/types/qr'

export class ApiError extends Error {
  code: string
  raw?: unknown
  constructor(code: string, message: string, raw?: unknown) {
    super(message)
    this.code = code
    this.raw = raw
  }
}

/**
 * baseURL = VITE_QR_API_HOST + '/vending-machine/api'
 *   - dev:VITE_QR_API_HOST 空字串 → 走 vite proxy(維持原本走法)
 *   - production:docker/.env 內為占位字串 `QR_API_HOST`,
 *     容器啟動時由 entrypoint sed 換成 argo 環境變數 $QR_API_HOST 的值
 */
const apiHost = import.meta.env.VITE_QR_API_HOST ?? ''
const http: AxiosInstance = axios.create({
  baseURL: `${apiHost}/vending-machine/api`,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

http.interceptors.response.use(
  (resp) => {
    const body = resp.data as ApiResp<unknown>
    if (body && typeof body === 'object' && 'code' in body) {
      if (body.code !== RESP_OK) {
        throw new ApiError(body.code, body.message ?? '未知錯誤', body)
      }
      return resp
    }
    return resp
  },
  (err: AxiosError<ApiResp<unknown>>) => {
    const body = err.response?.data
    if (body && body.code) {
      return Promise.reject(new ApiError(body.code, body.message ?? err.message, body))
    }
    return Promise.reject(new ApiError('NETWORK', err.message || '網路錯誤'))
  },
)

export async function unwrap<T>(p: Promise<{ data: ApiResp<T> }>): Promise<T> {
  const resp = await p
  return resp.data.data
}

export default http
